import styles from './styles.module.scss'

type Props = {
    children: React.ReactNode
    open: any
    close?: (e: boolean) => void
    className?: any
    closeOnOutsideClick?: boolean
}
export default function CustomModal({
    children,
    open,
    className,
    close,
    closeOnOutsideClick = false,
}: Props) {
    if (!open) return null

    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (closeOnOutsideClick && close && e.target === e.currentTarget) {
            close(false)
        }
    }

    return (
        <div className={` ${styles.overlay}`} onClick={handleOverlayClick}>
            <div className={`${className} ${styles.modal}`}>{children}</div>
        </div>
    )
}
